module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/picaro-bb98077afa8f90c80b5570d2940a0b7c.webp";